export const websiteConfigurationActionTypes = {
  START_ADD_OR_UPDATE_CONFIGURATION: "START_ADD_OR_UPDATE_CONFIGURATION",
  ADD_OR_UPDATE_CONFIGURATION_SUCCESS: "ADD_OR_UPDATE_CONFIGURATION_SUCCESS",
  ADD_OR_UPDATE_CONFIGURATION_FAILURE: "ADD_OR_UPDATE_CONFIGURATION_FAILURE",

  START_DELETE_CONFIGURATION: "START_DELETE_CONFIGURATION",
  DELETE_CONFIGURATION_SUCCESS: "DELETE_CONFIGURATION_SUCCESS",
  DELETE_CONFIGURATION_FAILURE: "DELETE_CONFIGURATION_FAILURE",

  START_GET_CONFIGURATION_BY_KEY: "START_GET_CONFIGURATION_BY_KEY",
  GET_CONFIGURATION_BY_KEY_SUCCESS: "GET_CONFIGURATION_BY_KEY_SUCCESS",
  GET_CONFIGURATION_BY_KEY_FAILURE: "GET_CONFIGURATION_BY_KEY_FAILURE",

  START_GET_ALL_CONFIGURATIONS: "START_GET_ALL_CONFIGURATIONS",
  GET_ALL_CONFIGURATIONS_SUCCESS: "GET_ALL_CONFIGURATIONS_SUCCESS",
  GET_ALL_CONFIGURATIONS_FAILURE: "GET_ALL_CONFIGURATIONS_FAILURE",

  START_UPLOAD_IMAGE: "START_UPLOAD_LOGO_IMAGE",
  UPLOAD_IMAGE_SUCCESS: "UPLOAD_LOGO_IMAGE_SUCCESS",
  UPLOAD_IMAGE_FAILURE: "UPLOAD_LOGO_IMAGE_FAILURE",

  START_DELETE_HOME_BANNER: "START_DELETE_HOME_BANNER",
  DELETE_HOME_BANNER_SUCCESS: "DELETE_HOME_BANNER_SUCCESS",
  DELETE_HOME_BANNER_FAILURE: "DELETE_HOME_BANNER_FAILURE",
};
